// 

export const getParents = (element) => {
  const parents = [];
  while (element) {
    parents.push(element);
    element = element.parentNode;
  }
  return parents;
};

export const getParentScrollableElement = (element) => {
  if (element === null) {
    return null;
  }

  if (element.scrollHeight > element.clientHeight && window.getComputedStyle(element).overflowX !== 'visible') {
    return element;
  }

  return getParentScrollableElement(element.parentNode);
};

export const dispatchEvent = (
  element,
  eventName,
  detail,
  canBubble = true,
  cancelable = true,
) => {
  if (!element) {
    throw new Error('Element is not defined');
  }
  const event = document.createEvent('CustomEvent');
  event.initCustomEvent(
    eventName,
    canBubble,
    cancelable,
    detail,
  );
  element.dispatchEvent(event);
  return event;
};

/**
 * Map of tags which have predefined values with regard to whitespace.
 */
const predefinedTagsValues = {
  IMG: ' ',
  BR: '\n',
};

const tagsToIgnore = {
  SCRIPT: 1,
  STYLE: 1,
  HEAD: 1,
  IFRAME: 1,
  OBJECT: 1,
};

const getTextContentOfPart = (node, buf, normalizeWhitespace) => {
  if (node.nodeName in tagsToIgnore) {
    // ignore certain tags
  } else if (node.nodeType === 3) {
    if (normalizeWhitespace) {
      buf.push(String(node.nodeValue)
        .replace(/(\r\n|\r|\n)/g, ''));
    } else {
      buf.push(node.nodeValue);
    }
  } else if (node.nodeName in predefinedTagsValues) {
    buf.push(predefinedTagsValues[node.nodeName]);
  } else {
    let child = node.firstChild;
    while (child) {
      getTextContentOfPart(child, buf, normalizeWhitespace);
      child = child.nextSibling;
    }
  }
};

export const textContent = (element, optValue) => {
  const text = (
    element.textContent != null ? 'textContent' : 'innerText'
  );

  if (typeof optValue !== 'undefined') {
    element[text] = optValue;
  }

  let textContent = element[text];
  const buf = [];
  getTextContentOfPart(element, buf, true);
  textContent = buf.join('');

  // Strip &shy; entities. goog.format.insertWordBreaks inserts them in Opera.
  textContent = textContent.replace(/ \xAD /g, ' ')
    .replace(/\xAD/g, '');
  // Strip &#8203; entities. goog.format.insertWordBreaks inserts them in IE8.
  textContent = textContent.replace(/\u200B/g, '');

  // Skip this replacement on old browsers with working innerText, which
  // automatically turns &nbsp; into ' ' and / +/ into ' ' when reading
  // innerText.
  if (!element.textContent != null) {
    textContent = textContent.replace(/ +/g, ' ');
  }
  if (textContent !== ' ') {
    textContent = textContent.replace(/^\s*/, '');
  }

  return textContent;
};

const textFieldTypes = [
  'date',
  'datetime',
  'datetime-local',
  'email',
  'month',
  'number',
  'password',
  'search',
  'tel',
  'text',
  'time',
  'url',
  'week',
];

// @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
const selectableFieldTypes = [
  'password',
  'search',
  'tel',
  'text',
  'url',
];

export const isTextField = (element) => {
  if (!element) {
    return false;
  }
  const tagName = element.tagName.toLowerCase();
  return (
    tagName === 'textarea' ||
    (
      tagName === 'input' &&
      textFieldTypes.includes(element.getAttribute('type'))
    )
  );
};

export const isSelectableField = (element) => {
  return isTextField(element) && selectableFieldTypes.includes(element.getAttribute('type'));
};

export const isVisible = (element) => {
  return !!( element.offsetWidth || element.offsetHeight || element.getClientRects().length )
};

export const isFocusable = (element) => {
  const tabIndexSelector = ':not([tabindex="-1"])';
  const notDisabledSelector = ':not([disabled])';
  const focusableSelector = [
    'button',
    'href',
    'input',
    'select',
    'textarea',
    '[tabindex]',
  ]
    .map((selector) => `${selector}${tabIndexSelector}${notDisabledSelector}`)
    .join(',');

  return isVisible(element) && element.matches(focusableSelector);
};


export const getFocusAnchor = () => {
  const activeElement = document.activeElement;
  const textField = isTextField(activeElement);
  let startPosition = -1;
  const endPosition = -1;
  if (textField) {
    try {
      startPosition = activeElement.selectionStart;
    } catch (e) {
      // na ios dochází k chybě na type date dateinput time a nevím kde dále
      // silent
    }
  }

  return {
    id: activeElement ? activeElement.getAttribute('id') : null,
    textField,
    startPosition,
    // zatím -1
    endPosition,
  };
};

export const setFocusAnchor = (focusAnchor) => {
  if (!focusAnchor) {
    return;
  }

  const {
    id,
    startPosition,
    endPosition,
    textField,
  } = focusAnchor;

  if (id) {
    const newElement = document.getElementById(id);
    if (newElement) {
      if (isFocusable(newElement) && newElement.focus) {
        newElement.focus();
        if (isSelectableField(newElement) && startPosition > -1) {
          newElement.setSelectionRange(
            startPosition,
            endPosition === -1 ? startPosition : endPosition,
          );
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/lib/dom.js